import { render, staticRenderFns } from "./simulate.vue?vue&type=template&id=8b0a3eee&scoped=true&"
import script from "./simulate.vue?vue&type=script&lang=js&"
export * from "./simulate.vue?vue&type=script&lang=js&"
import style0 from "./simulate.vue?vue&type=style&index=0&id=8b0a3eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0a3eee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VApp,VBtn,VSlider,VSnackbar,VSubheader})
